




















































































import {Component, Watch, Vue} from 'vue-property-decorator';
import {cloneDeep, isEqual} from 'lodash';
import CSelect from '@/components/base/select/CSelect.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import {mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';
@Component({
    components: {CNumberField, CCheckbox, CSelect},
    computed: {
        ...mapState('planEdit', ['planEdit']),
    },
})
export default class PlanSettings extends Vue {
    private data: any = null;
    private initialData: any = null;
    private loading = false;
    private editing = false;

    public planEdit!: PlanEditModel | null;

    get hasUnsavedChanges() {
        return !isEqual(this.data, this.initialData);
    }

    @Watch('hasUnsavedChanges')
    onHasUnsavedChangesChange(value: boolean) {
        this.$root.$emit('plan_edit:unsaved_changes', value);
    }

    @Watch('editing')
    onEditingChange(value: boolean) {
        this.$emit('tab-edit', value);
    }

    created() {
        this.$root.$on('plan_edit:unsaved_changes:reset', this.reset);
        this.getData();
    }

    beforeDestroy() {
        this.$root.$off('plan_edit:unsaved_changes:reset', this.reset);
    }

    async getData() {
        this.loading = true;
        try {
            const {data} = await this.$http.get(`${this.$api.journals.plan}/GetSettings`, {
                params: {
                    id: this.$route.params.idPlan,
                },
            });
            this.data = data;
            this.initialData = cloneDeep(data);
        } finally {
            this.loading = false;
        }
    }

    async save() {
        if (this.planEdit?.IsApproved) return;
        const timerId = setTimeout(() => (this.loading = true), 150);
        try {
            const {data} = await this.$http.post(
                `${this.$api.journals.plan}/SaveSettings`,
                {...this.data},
                {
                    params: {
                        id: this.$route.params.idPlan,
                    },
                },
            );
            this.data = data;
            this.initialData = cloneDeep(data);
        } finally {
            clearTimeout(timerId);
            this.loading = false;
            this.editing = false;
        }
    }

    reset() {
        this.data = cloneDeep(this.initialData);
        this.editing = false;
    }

    onEdit() {
        this.editing = true;
    }
}
